<template>
  <v-container fluid>
    <template v-if="details">
      <v-row wrap>
        <v-col cols="6" class="py-1">
          <DisplayField label="Year" :value="details.year" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Make" :value="details.make" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Model" :value="details.model" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Hull ID" :value="details.vin" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Name" :value="details.boat.name" />
        </v-col>
      </v-row>

      <template v-if="viewingMore">
        <v-divider />
        <v-row wrap>
          <v-col cols="6" class="py-1">
            <DisplayField label="Length" :value="details.boat.length" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="HP" :value="details.boat.horsePower" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Engines" :value="details.boat.numberOfEngines" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Speed" :value="details.boat.speed" />
          </v-col>

          <v-col cols="6" class="py-1">
            <DisplayField label="Stored" :value="storageType" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Marina Name" :value="details.boat.marinaName" />
          </v-col>

          <v-col cols="6" class="py-1">
            <DisplayField label="Propulsion" :value="propType" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Construction" :value="constructionType" />
          </v-col>

          <v-col cols="6" class="py-1">
            <DisplayField label="Fuel" :value="fuelType" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Vessel Type" :value="boatType" />
          </v-col>

          <v-col cols="12" class="py-1">
            <DisplayField label="Territory" :value="details.territory" />
          </v-col>

          <v-col cols="6" class="py-1">
            <DisplayField label="Use" :value="useType" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Halon" :value="halon" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Survey Completed" :value="details.boat.surveyCompletedDate" type="date" />
          </v-col>
          <v-col cols="12" class="py-1">
            <DisplayField label="Additional Information" :value="details.additionalInfo" />
          </v-col>
        </v-row>
      </template>

      <v-row justify="end">
        <v-col cols="6" class="text-end">
          <a class="link" @click="toggleView">
            {{ viewMoreText }}
          </a>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="px-0 py-0">
          <AdditionalInterests :data="details.additionalInterests" />
        </v-col>
      </v-row>

    </template>
    <template v-else-if="!loading">
      <v-row>
        <v-col>
          Unable to get information. Please try again later.
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading boat details...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.section-header {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #767676;
  }
</style>

<script>
import enumService from '@/services/shared/enumService.js';
import { mapState, mapActions } from 'vuex';

import DisplayField from '@/components/Shared/DisplayField.vue';
import AdditionalInterests from '@/components/Shared/AdditionalInterests.vue';

export default {
  name: 'BoatDetails',
  components: {
    AdditionalInterests,
    DisplayField
  },
  props: {
    details: {
      type: Object,
      default: null
    },
    loading: Boolean
  },
  data: function () {
    return {
      viewingMore: false,
      interestSelected: false,
      selectedInterest: null
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    vehicleId: function () {
      return this.$route.params.vehicleId;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    constructionType: function () {
      return (((this.details || null) === null) ||
              ((this.details.boat || null) === null) ||
              this.details.boat.boatConstructionType === 0) ? '' : enumService.boatConstructionTypes[this.details.boat.boatConstructionType];
    },
    storageType: function () {
      return (((this.details || null) === null) ||
              ((this.details.boat || null) === null) ||
              this.details.boat.boatStorageType === 0) ? '' : enumService.boatStorageTypes[this.details.boat.boatStorageType];
    },
    propType: function () {
      return (((this.details || null) === null) ||
              ((this.details.boat || null) === null) ||
               this.details.boat.boatPropulsionType === 0) ? '' : enumService.boatPropulsionTypes[this.details.boat.boatPropulsionType];
    },
    boatType: function () {
      return (((this.details || null) === null) ||
              ((this.details.boat || null) === null) ||
               this.details.boat.boatType === 0) ? '' : enumService.boatTypes[this.details.boat.boatType];
    },
    fuelType: function () {
      return (((this.details || null) === null) ||
              ((this.details.boat || null) === null) ||
               this.details.boat.boatFuelType === 0) ? '' : enumService.boatFuelTypes[this.details.boat.boatFuelType];
    },
    useType: function () {
      return (((this.details || null) === null) ||
              ((this.details.boat || null) === null) ||
               this.details.boat.boatUseType === 0) ? '' : enumService.boatUseTypes[this.details.boat.boatUseType];
    },
    halon: function () {
      if ((this.details.boat || null) === null) return '';
      if ((this.details.boat.halon || null) === null) return '';
      return this.details.boat.halon ? 'Y' : 'N';
    }
  },
  methods: {
    ...mapActions(['setError']),
    toggleView: function () {
      this.viewingMore = !this.viewingMore;
    }
  }
};
</script>
